import AxiosLib from "axios";
import { createApp } from "vue";
import BundlesApp from "../../components/pages/campaigns/bundles";

window.axios = AxiosLib;

const app = createApp();

app.component("bundles-app", BundlesApp);
app.mount("#bundles-app");
